import { Loader, Select, SelectProps } from "@mantine/core";

export type BaseSelectProps = Omit<SelectProps, "rightSection"> & {
  loading?: boolean;
};

export function BaseSelect(props: BaseSelectProps) {
  const { loading, ...rest } = props;

  return (
    <Select
      rightSection={loading ? <Loader size="sm" /> : undefined}
      {...rest} />
  );
}
